import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { baseUrl, liveRateUrl } from "../constant.js";
const Allmarketwatch = (
  {
    title,
    exparydate,
    token,
    catid,
    high,
    low,
    ltp,
    buy,
    sell,
    changeprice,
    percentagepricechange,
  },
  index,
) => {
  const [price, setPrice] = useState();
  const [previousPrice, setPreviousPrice] = useState();

  const [colour, setcolour] = useState("");

  const [liveratedata, setLiveRate] = useState([]);
  const navigate = useNavigate();
  const onbuttonclick = async () => {
    const token1 = token;
    const tokenheader = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("Token", tokenheader);
    formdata.append("token", token1);
    const rate = await axios.post(liveRateUrl, formdata);
    const fathdata = await rate.data.livedata[0];
    navigate("/markettrade", {
      state: {
        name: title,
        token: token1,
        exparydate: exparydate,
        catid: catid,
      },
    });
  };
  const getBuyColor = () => {
    const themelight = localStorage.getItem("background");
    const previousBuyPrice = localStorage.getItem(token + "-Buy-Price");
    if (previousBuyPrice > buy) {
      localStorage.setItem(token + "-Buy-Price", buy);
      return { backgroundColor: "red" };
    } else if (previousBuyPrice < buy) {
      localStorage.setItem(token + "-Buy-Price", buy);
      return { backgroundColor: "green" };
    } else if (previousBuyPrice === buy) {
      localStorage.setItem(token + "-Buy-Price", buy);
      return { backgroundColor: "" };
    } else {
      localStorage.setItem(token + "-Buy-Price", buy);

      if (themelight == 0) {
        return { backgroundColor: "#1e293b" };
      } else if (themelight == 1) {
        return { backgroundColor: "#edf9fe" };
      } else if (themelight == 2) {
        return { backgroundColor: "#1e5655" };
      }
    }
  };
  const getSellColor = () => {
    const previousSellPrice = localStorage.getItem(token + "-Sell-Price");
    if (previousSellPrice > sell) {
      localStorage.setItem(token + "-Sell-Price", sell);
      return { backgroundColor: "red" };
    } else if (previousSellPrice < sell) {
      localStorage.setItem(token + "-Sell-Price", sell);
      return { backgroundColor: "green" };
    } else {
      localStorage.setItem(token + "-Buy-Price", buy);

      const themelight = localStorage.getItem("background");
      if (themelight == 0) {
        return { backgroundColor: "#1e293b" };
      } else if (themelight == 1) {
        return { backgroundColor: "#edf9fe" };
      } else if (themelight == 2) {
        return { backgroundColor: "#1e5655" };
      }
    }
  };
  const getColorStyle = () => {
    if (changeprice > 0) {
      return { color: "#00ADB5", marginTop: "15px" };
    } else if (changeprice < 0) {
      return { color: "red", marginTop: "15px" };
    }
    return {};
  };

  return (
    <>
      <div className="tab_search_body" key={index}>
        <Link
          to=""
          onClick={() => {
            {
              onbuttonclick();
            }
          }}
        >
          <div className="futures_List">
            <div className="futures_list_text">
              <h3>{title}</h3>
              <h5>{exparydate}</h5>
              <h6 style={getColorStyle()}>
                Chg:{changeprice} ({percentagepricechange}){" "}
              </h6>
            </div>
            <div className="futures_list_text flt text-center">
              <h5 style={{ marginTop: "37px" }}>High: {high}</h5>
            </div>
            <div className="futures_lot_size">
              <h4 style={getBuyColor()}>{buy}</h4>
              <h5>Low {low}</h5>
            </div>
            <div className="futures_lot_size">
              <h4 style={getSellColor()}>{sell}</h4>
              <h5>Ltp: {ltp}</h5>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default Allmarketwatch;
